function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6088 2.89108C14.7785 3.06086 14.8361 3.31288 14.7567 3.53949L10.0901 16.8728C10.0054 17.1147 9.78169 17.2804 9.52564 17.2908C9.26959 17.3013 9.03311 17.1544 8.92903 16.9202L6.35999 11.1399L0.579663 8.57083C0.345487 8.46675 0.198573 8.23027 0.209019 7.97422C0.219465 7.71817 0.385155 7.49444 0.62703 7.40978L13.9604 2.74311C14.187 2.6638 14.439 2.72131 14.6088 2.89108ZM2.52792 8.06882L7.08733 10.0952C7.22873 10.1581 7.34179 10.2711 7.40463 10.4125L9.43104 14.9719L13.1481 4.35176L2.52792 8.06882Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.5796 2.86393C19.7706 3.0321 19.8406 3.29929 19.7565 3.53949L15.0899 16.8728C15.0087 17.1048 14.7991 17.2676 14.5542 17.289C14.3094 17.3103 14.0747 17.1862 13.9547 16.9718L12.7878 14.8884C12.6191 14.5873 12.7266 14.2064 13.0277 14.0377C13.3289 13.869 13.7097 13.9764 13.8784 14.2776L14.3679 15.1516L18.0675 4.58128L16.9459 5.14204C16.6372 5.2964 16.2618 5.17125 16.1074 4.86251C15.9531 4.55377 16.0782 4.17835 16.387 4.02399L18.8871 2.77399C19.1147 2.66019 19.3886 2.69576 19.5796 2.86393Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6093 2.89107C14.8533 3.13514 14.8533 3.53087 14.6093 3.77495L7.27593 11.1083C7.03185 11.3524 6.63612 11.3524 6.39204 11.1083C6.14797 10.8642 6.14796 10.4685 6.39204 10.2244L13.7254 2.89107C13.9695 2.64699 14.3652 2.64699 14.6093 2.89107Z",
  fill: "currentColor"
});

function SvgMailMergeTutorial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailMergeTutorial);
export default __webpack_public_path__ + "static/media/mail-merge-tutorial.060df45e.svg";
export { ForwardRef as ReactComponent };